import { createRichSnippetStructuredDataContext } from '@big-red-group/storefront-common-ui'

export const RichSnippetContext = createRichSnippetStructuredDataContext()
